(function() {
  define('bazemont/news/content',['angular'], function() {
    'use strict';
    return angular.module('bazemontNewsContent', []).component('bazemontNewsContent', {
      template: '<tlh-editable-content ng-model="$ctrl.content" class="fr-view" editor-config="$ctrl.editorConfig" images-max-width="738"></tlh-editable-content>',
      bindings: {
        content: '='
      },
      controller: function() {
        var toolbarButtons, vm;
        vm = this;
        toolbarButtons = ['bold', 'italic', 'underline', 'strikeThrough', 'subscript', 'superscript', '|', 'paragraphFormat', 'align', 'formatOL', 'formatUL', 'outdent', 'indent', '|', 'insertLink', 'insertImage', 'insertVideo', 'insertFile', 'insertTable', 'insertHR', '|', 'undo', 'redo', 'clearFormatting', 'selectAll'];
        vm.editorConfig = {
          paragraphFormat: {
            H3: 'Titre paragraphe',
            N: 'Texte simple'
          },
          pluginsEnabled: ['align', 'draggable', 'file', 'image', 'lineBreaker', 'link', 'lists', 'paragraphFormat', 'quote', 'table', 'url', 'video'],
          imageDefaultAlign: 'left',
          imageDefaultDisplay: 'inline',
          toolbarButtons: toolbarButtons,
          toolbarButtonsMD: toolbarButtons,
          toolbarButtonsSM: toolbarButtons,
          toolbarButtonsXS: toolbarButtons
        };
      }
    });
  });

}).call(this);

//# sourceMappingURL=content.js.map
;
